import {Component, ViewChild} from '@angular/core';
import {Keyboard, ModalController, NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from "../../../app/config";
import {CLOSE_PAGE} from "../../../app/import";
import {NavRepository} from "../../../repositories/nav-repository";
import {ModalActionPage} from "../modal-action/modal-action";
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {
    TAction,
    TFinanceSide,
    TCarsale,
    TMethodoTipo,
    TPlasticSafe,
    TConsumoFlag,
} from "../../../app/enum";
import {DragButton} from "../../../components/drag-button/drag-button";
import {ProfileService} from "../../../providers/profile-service";
import {ProfileRepository} from "../../../repositories/profile-repository";
import {LogadoService} from "../../../providers/logado-service";
import {CarbookService} from "../../../providers/carbook-service";
import {WebstorService} from "../../../providers/webstor-service";
import {DomSanitizer} from "@angular/platform-browser";
import {PrivacyMenuPage} from "../privacy-menu/privacy-menu";

@Component({
    selector: 'page-plastic-menu',
    templateUrl: 'plastic-menu.html',
    providers: [ProfileService, ProfileRepository, WebstorService],
})
export class PlasticMenuPage {

    TFinanceSide: any = TFinanceSide;
    TConsumoFlag: any = TConsumoFlag;

    config: any;
    logado: any;

    plastic: any;
    carbook: any;

    readonly: boolean;
    rootile: any;
    methodos: any;
    plastics: any;

    profileSelf: boolean;

    braspag: any = {braspagToken: '', braspagOrgId: '', bpPBG: '', bpImgSrc: '', bpFlashData: '', bpJsSrc: ''};

    etapa: number;

    @ViewChild(DragButton) dragButton: DragButton;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public util: Util,
                public sanitizer: DomSanitizer, public navRepository: NavRepository,
                public viewCtrl: ViewController, public modalCtrl: ModalController,
                public logadoService: LogadoService, private keyboard: Keyboard,
                public profileService: ProfileService, public profileRepository: ProfileRepository,
                public webstorService: WebstorService, public carbookService: CarbookService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa = this.navParams.get('etapa');
        this.rootile = this.navParams.get('rootile');
        this.readonly = this.navParams.get('readonly');
        this.plastic = this.util.deepCopy(this.navParams.get('plastic'));
        this.plastics = this.navParams.get('plastics');
        this.carbook = this.carbookService.getCarrinho();

        this.profileSelf = (this.logado.Profile.ProfileID == this.rootile.Profile.ProfileID);

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Plastic Menu', '/plastic-menu');

        if (this.etapa == 0) this.plasticLoad();
        if (this.etapa == 1) this.plasticNovo();
        if (this.etapa == 3) this.methodoLoad();
        if (this.etapa == 6) this.braspagCode();

    }

    getTitle() {

        let novoEditar = (this.plastic && this.plastic.PlasticID) ? 'Editar Cartão' : 'Novo Cartão';

        if (this.etapa == 1) return novoEditar;
        if (this.etapa == 3) return 'Bandeira';
        if (this.etapa == 4) return 'Autorizar';
        if (this.etapa == 5) return 'Autenticar';
        if (this.etapa == 6) return 'Pagamento';

    }

    onChange() {

        if (this.plastic.PlasticAuth.length == 3) this.keyboard.close();

    }

    birthday(plastic) {

        //Receita Federal
        this.profileRepository.birthday(PrivacyMenuPage, true, this.logado.Profile)
            .subscribe(data => {

            //Cartão Liberado Seleciona
            if (plastic.PlasticSafe == TPlasticSafe.psSafe) {
                this.plasticCart(plastic);
                return;
            }

            this.plasticSafe(plastic);

        });

    }

    methodoLoad() {

        let onBand = (data) => {
            this.etapa = 3
            this.methodos = data.Methodos;
        }

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.methodo(TAction.acLoad, TMethodoTipo.mtCard)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onBand(data), //this.methodos = data.Methodos,
                erro => this.util.alertResult(erro)
            );

    }

    plasticSide(methodo, side?) {

        /** DEFINE **/
        if (side) {
            this.plastic.Methodo = methodo;
            this.plastic.PlasticSide = side;
            return;
        }

        /** CHOICE **/
        let debito = (methodo.MethodoSide == TFinanceSide.cdCredito);

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Crédito', handler: () => this.plasticSide(methodo, TFinanceSide.cdCredito)});
        if (debito) buttons.push({text: 'Débito', handler: () => this.plasticSide(methodo, TFinanceSide.cdDebito)});
        if (debito) buttons.push({text: 'Cancelar', role: 'destructive'});
        this.util.sheetOpen(buttons, 'Operação');

    }

    braspagCode() {

        let date = new Date();
        let month = (date.getMonth() + 1).toString();
        month = (month.length == 2 ? '' : '0') + month;

        this.braspag.braspagToken = this.logado.Profile.ProfileID + date.getFullYear() + month + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds().toString().substr(0, 2);
        this.braspag.braspagOrgId = this.config.spotus.Interface.braspagOrgId;

        this.braspag.bpPBG       = 'https://h.online-metrix.net/fp/clear.png?org_id=' + this.braspag.braspagOrgId + '&session_id=braspag_kairus' + this.braspag.braspagToken + ';m=1';
        this.braspag.bpImgSrc    = 'https://h.online-metrix.net/fp/clear.png?org_id=' + this.braspag.braspagOrgId + '&session_id=braspag_kairus' + this.braspag.braspagToken + '';
        this.braspag.bpFlashData = 'https://h.online-metrix.net/fp/fp.swf?org_id='    + this.braspag.braspagOrgId + '&session_id=braspag_kairus' + this.braspag.braspagToken + '';
        this.braspag.bpJsSrc     = 'https://h.online-metrix.net/fp/check.js?org_id='  + this.braspag.braspagOrgId + '&session_id=braspag_kairus' + this.braspag.braspagToken + '';

    }

    plasticLoad() {

        let loading = this.util.loadingDots();
        loading.present();

        this.profileService.plastic(TAction.acLoad, this.rootile.Profile.ProfileID, 0)
            .finally(() => loading.dismiss())
            .subscribe(data => {

                this.plastics = data.Plastics;

            }, erro => {

                this.util.alertResult(erro);

            });

    }

    plasticNovo(plastic: any = null) {

        // NOVO ou EDIT
        if (!plastic) plastic = {Methodo: null, PlasticCard: '', PlasticNome: '', PlasticRnid: '', PlasticLife: '', PlasticSafe: TPlasticSafe.psWait, PlasticAuth: '', PlasticCash: 0};
        this.plastic = plastic;

        //Logado é mesmo que Perfil?
        if (!this.profileSelf) return;

        //this.etapa = 1;


        this.methodoLoad();

        //Cadastro de Forma de Pagamento
        // let objectData = {etapa: 1, readonly: false, rootile: this.rootile, plastic: plastic, plastics: this.plastics};
        // this.util.modalopen(PlasticMenuPage, 'alto', false, objectData).subscribe(
        //     data => {

        //         //Cadastrou o cartao, rola para ele
        //         //if (!data || !data.plasticCancel);

        //         //Cartão Liberado Seleciona
        //         this.plasticCart(plastic);

        //     });

    }

    plasticSave() {

        if (this.plastic.PlasticLife.length == 7) this.plastic.PlasticLife = this.plastic.PlasticLife + '-01';

        let alert = this.util.plasticAlert(this.plastic, false);
        if (alert) {
            this.util.alertSimply(alert, 'Obrigatório', 'Corrigir');
            return;
        }

        let loading = this.util.loadingDots('Salvando cartão...');
        loading.present();

        this.profileService.plastic(TAction.acSave, this.rootile.Profile.ProfileID, this.plastic.PlasticID, this.plastic.PlasticSide, this.plastic)
            .finally(() => loading.dismiss())
            .subscribe(data => {

                    //PlasticNovo
                    if (!this.plastic.PlasticID) {
                        this.plastic.PlasticID = data.Codigo;
                        this.plastics.splice(0, 0, this.plastic);
                    }

                    this.plasticSafe(this.plastic);

                },
                erro => {

                    this.util.alertResult(erro);

                });

    }

    plasticMode(plastic, side) {

        //Logado é mesmo que Perfil?
        if (!this.profileSelf) return;

        let loading = this.util.loadingDots('Trocando cartão...');
        loading.present();

        this.profileService.plastic(TAction.acMode, this.rootile.Profile.ProfileID, plastic.PlasticID, side)
            .finally(() => loading.dismiss())
            .subscribe(data => {

                plastic.PlasticSide = side;
        
                //Cartão Liberado Seleciona
                this.plasticCart(plastic);

            }, erro => {

                this.util.alertResult(erro);

            });

    }

    plasticLost(plastic) {

        //Logado é mesmo que Perfil?
        if (!this.profileSelf) return;

        let loading = this.util.loadingDots();
        loading.present();

        this.profileService.plastic(TAction.acLost, this.rootile.Profile.ProfileID, plastic.PlasticID)
            .finally(() => loading.dismiss())
            .subscribe(data => {

                let index = this.plastics.findIndex(plastic => plastic.PlasticID == plastic.PlasticID);
                this.plastics.splice(index, 1);
        
            }, erro => {

                this.util.alertResult(erro);

            })

    }

    plasticAuth() {

        if (this.plastic.PlasticAuth.length != 3) {
            //Volta Button para start
            if (this.dragButton) this.dragButton.setChecked(false);
            this.util.alertSimply('Preencha corretamente o CVV do cartão para continuar.', 'Obrigatório', 'Corrigir');
            return;
        }

        let alerta = 'Faremos uma cobrança de autenticação no valor entre R$ 1,00 e R$ 10,00 em seu cartão de crédito, que depois será reembolsada automáticamente em até 2 dias.';
        this.util.alertQuestion('ATENÇÃO', alerta, 'Continuar', () => {

            let loading = this.util.loadingDots('Debitando no cartão...');
            loading.present();

            this.profileService.plastic(TAction.acAuth, this.logado.Profile.ProfileID, this.plastic.PlasticID, this.plastic.PlasticSide, this.plastic)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => {

                        this.etapa = 5;
                        this.plastic.PlasticSafe = TPlasticSafe.psWait;

                    },
                    erro => {

                        //Volta Button para start
                        if (this.dragButton) this.dragButton.setChecked(false);

                        this.util.alertResult(erro);

                    });

        });

    }

    plasticCash() {

        if (!this.plastic.PlasticCash) {
            //Volta Button para start
            if (this.dragButton) this.dragButton.setChecked(false);
            this.util.alertSimply('Informe o valor debitado em sua conta para continuar.', 'Obrigatório', 'Corrigir');
            return;
        }

        let loading = this.util.loadingDots('Autenticando cartão...');
        loading.present();

        this.profileService.plastic(TAction.acCash, this.logado.Profile.ProfileID, this.plastic.PlasticID, this.plastic.PlasticSide, this.plastic)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    this.plastic.PlasticSafe = TPlasticSafe.psSafe;
                    if (!this.readonly) this.dismiss();
                    if ( this.readonly) this.plasticCart(this.plastic);

                },
                erro => {

                    //Volta Button para start
                    if (this.dragButton) this.dragButton.setChecked(false);

                    this.util.alertResult(erro);

                });

    }

    plasticSafe(plastic) {

        //Cartao já Autenticado
        if (plastic.PlasticSafe == TPlasticSafe.psSafe) {
            this.dismiss();
            return;
        }


        // 4-Auth ou 5-Cash
        let etapasend = (!plastic.PlasticData ? 4 : 5);
        let objectPay = {etapa: etapasend, readonly: this.readonly, rootile: this.rootile, plastic: plastic};

        let onThen = () => this.navCtrl.getPrevious().dismiss({plasticCancel: false});

        this.util.modalopen(PlasticMenuPage, 'alto', false, objectPay, null, null, null, onThen).subscribe(
            data => this.util.statusBarColor(TStatusBar.sbStyleDefault)
        );

    }

    plasticMenu(etapa) {

        let objectData = {etapa: etapa, readonly: false, rootile: this.rootile};
        this.util.modalopen(PlasticMenuPage, 'alto', false, objectData).subscribe(
            data => {
                //if (!data || !data.methodo) return;
                //if (etapa == 3) this.plastic.Methodo = data.methodo;
            });

    }

    paymentCard() {

        if (this.plastic.PlasticAuth.length != 3) {
            //Volta Button para start
            if (this.dragButton) this.dragButton.setChecked(false);
            this.util.alertSimply('Preencha corretamente o CVV do cartão para continuar.', 'Obrigatório', 'Corrigir');
            return;
        }


        //Volta Button para start
        if (this.dragButton) this.dragButton.setChecked(false);


        let onPlus = (okey, that, data) => {

            this.util.open('', '_blank', data.Html);

        };

        let onOkey = (okey, that, data) => {

            if (okey.action) {
                that.openStore();
                that.dismiss();
                return;
            }

            let carsale = this.carbook.Carsale;
            let native = this.util.nativeApp();

            let titulo = '';
            if (carsale == TCarsale.csValida)  titulo = 'Cartão Validado';
            if (carsale == TCarsale.csNormal)  titulo = 'Parcela Paga';
            if (carsale == TCarsale.csPayout)  titulo = 'Saída Liberada';
            if (carsale == TCarsale.csMerito)  titulo = 'Meritum Adquirido';
            if (carsale == TCarsale.csTicket)  titulo = 'Voucher Adquirido';

            let linhas = [];

            if (carsale == TCarsale.csMerito) {
                let expira = this.util.dataft(this.carbook.Paybooks[0].Consumos[0].Consumo_Nova_Data_Expira_Meritum, null, 'char', 'yyyy');
                linhas.push({text: 'Válido até <b>' + expira + '</b>.', right: null, color: null});
            }

            if (carsale == TCarsale.csTicket) {
                linhas.push({text: '<b>Seu voucher</b> já está disponível.', right: null, color: null});
                linhas.push({text: 'Use seu <b>QRCode</b> na entrada.', right: null, color: null});
            }

            okey.window = 'animeerro';
            okey.corcor = 'CorRoxa';
            okey.header = 'PRONTO';
            okey.titulo = titulo;
            okey.resumo = (native ? null : 'Baixe o <b>LOREAN</b> na loja.');
            okey.imagem = (carsale == TCarsale.csValida ? this.plastic.Methodo.MethodoLogo : 'b-icon-check');
            okey.stores = null;
            okey.action = (native ? null : {name: 'Baixar', round: false, small: false, plus: null});
            okey.observ = null;
            okey.linhas = linhas;

        };

        //Credito
        let observ = this.carbookService.payCrebito(this.braspag.braspagToken);

        let objectData = {modalinfo: this.config.modalinfo(this.util, 'animeload', onOkey, onPlus, false, null, observ)};
        objectData.modalinfo.titulo = 'Processando...';
        objectData.modalinfo.imagem = this.plastic.Methodo.MethodoLogo;

        let onGate = () => {

            //Update Voucher Qtde
            if (this.carbook.Carsale == TCarsale.csTicket) {
                let index = this.carbook.Paybooks.findIndex(PB => (PB.Profile.ProfileID == this.logado.Profile.ProfileID));
                if (index >= 0) this.logadoService.voucherQtde(1);
            }

            //Update Certify Expira
            let meritum = this.carbook.Hotspot;
            if (this.carbook.Carsale == TCarsale.csMerito) this.logadoService.meritumPush(meritum);

            //Limpar carrinho
            this.carbookService.setStart(null, null);

            this.carbookService.payfim();
            this.navRepository.closePage(this.navCtrl, CLOSE_PAGE).subscribe();

        };

        this.util.modalopen(ModalActionPage, 'wide', true, objectData)
            .subscribe(
                data => {
                    //Deu sucesso, volta tudo
                    if (data && !data.Result) onGate();
                });

    }

    plasticCart(plastic) {

        if (!this.readonly || this.util.plasticAlert(plastic, true)) return;

        //Update Tela Carrinho com nova forma selecionada
        this.carbook.Payforma.Plastic = plastic;
        this.carbook.Payforma.Methodo = plastic.Methodo;

        /** ATENÇÃO - GAMBI EMITTER **/
        /** *********************** **/
        //O message cai varias vezes quando abre a janela e fecha
        //Esta chamando como dismiss() por conta disso, senao da pop em janelas erradas.
        //this.navCtrl.pop();
        this.viewCtrl.dismiss();

    }

    plasticCard(plastic) {

        //Logado é mesmo que Perfil?
        if (!this.profileSelf) return;


        //Purchase - Seleciona o cartão
        if ( this.readonly) {
            this.birthday(plastic);
            return;
        }


        //Janela de ação
        let validade = this.util.strToDate(plastic.PlasticLife);
        let validate = (this.util.diaLast(validade) >= this.util.diaLast(new Date));
        let cardedit = this.util.plasticAlert(plastic, true);
        let cardauth = !this.util.plasticAlert(plastic, false);
        let cardsafe = (plastic.PlasticSafe == TPlasticSafe.psSafe);

        let buttons: Array<any> = [];

        /** AUTH **/
        if (!cardsafe && cardauth && validate) {
            buttons.push({text: 'Autenticar', handler: () => this.birthday(plastic)});
        }

        /** EDIT **/
        if (!cardsafe && cardedit && (!validade || validate)) {
            buttons.push({text: 'Editar', handler: () => this.plasticNovo(plastic)});
        }

        /** MODO **/
        else if (plastic.Methodo.MethodoSide == TFinanceSide.cdCredito) {
            let side = this.util.invert(plastic.PlasticSide, TFinanceSide.cdCredito, TFinanceSide.cdDebito);
            let text = TFinanceSide[side].slice(2, 99);
            buttons.push({text: text, handler: () => this.plasticMode(plastic, side)});
        }

        /** LIXO **/
        buttons.push({text: 'Excluir', handler: () => this.plasticLost(plastic)});

        /** CANCELAR **/
        buttons.push({text: 'Cancelar', role: 'destructive'});

        /** OPEN **/
        this.util.sheetOpen(buttons, 'O que você deseja?');

    }

    tecladoOkey(btn) {
        
        let paymentText = this.util.dinheiro(this.plastic.PlasticCash);
        paymentText = paymentText.replace('R$', '');
        paymentText = paymentText.replace(',',  '');
        paymentText = paymentText.replace('.',  '');
        paymentText = paymentText.replace(' ',  '');

        if (btn == 'ok') {

            this.plasticCash();
            
        }

        else if (btn == 'cancel') {
            this.dismiss();
        }

        else if (btn == 'erase') {
            if (paymentText.length) paymentText = paymentText.substring(0, paymentText.length-1);
        }

        else if (btn == 'left-thin') {
            if (paymentText.length) paymentText = paymentText.substring(0, paymentText.length-1);
        }

        else if (btn == 'dot') {
            //this.tecladoText = this.tecladoText + '.';
        }

        else {
            if (paymentText.length <= 10) paymentText = paymentText + btn;
        }

        paymentText = paymentText.substring(0, paymentText.length-2) + '.' + paymentText.substring(paymentText.length-2, 99);

        let paymentReal = parseFloat(paymentText);
        if (paymentReal < 10) this.plastic.PlasticCash = paymentReal;

    }




    dismiss(data: any = null, cancel: boolean = false) {

        if (this.etapa == 3 && this.plastic) {
            this.etapa = 1;
            this.plastic.Methodo = data;
            return;
        }

        this.viewCtrl.dismiss({methodo: data, plasticCancel: cancel});

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/plastic-menu/plastic-menu.ts